// extracted by mini-css-extract-plugin
module.exports = {"ai-summary":"ai-summary_ai-summary__8OytY","ai-summary__title":"ai-summary_ai-summary__title__w7l31","ai-summary__icons":"ai-summary_ai-summary__icons___WODJ"};